export const RULES_SECTION_IDS = {
  OVERVIEW: 'overview',
  KEY_POINTS: 'keyPoints',
  CONSTRUCTION_PHASE: 'constructionPhase',
  SUPPLY_PHASE: 'supplyPhase',
  UNITS: 'units',
  WAR_PHASE: 'warPhase',
  INCOME: 'income',
  SCORING: 'scoring',
  POLICIES: 'policies',
  RANKED: 'ranked',
  BOTS: 'bots',
  FACTIONS: 'factions',
  INTERFACE: 'interface',
  ADVANCED: 'advanced',
};
